/* eslint-disable import/no-anonymous-default-export,import/no-default-export */
export default {
    xxs: '0.25rem',
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.25rem',
    xl: '2rem',
    xxl: '2.625rem',
};
//# sourceMappingURL=spacing.js.map